(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boks-app-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initApp(root) {
      if (!root || root.dataset.boksAppReady === '1') return;
      root.dataset.boksAppReady = '1';

      var screens = Array.prototype.slice.call(root.querySelectorAll('.boks-app__screen'));
      var texts   = Array.prototype.slice.call(root.querySelectorAll('.boks-app__text'));
      var dots    = Array.prototype.slice.call(root.querySelectorAll('.boks-app__dot'));
      var n = screens.length;
      if (n <= 1) return;

      var pinPref = root.dataset.pin === 'true';
      var speed = (parseFloat(root.dataset.speed) || 3) * 1000;
      var current = -1, timer = null, mode = '';

      var media = root.querySelector('.boks-app__media');

      function setActive(i) {
        if (i === current || i < 0 || i >= n) return;
        var first = (current === -1);
        current = i;
        for (var k = 0; k < n; k++) {
          var on = (k === i);
          if (screens[k]) screens[k].classList.toggle('is-active', on);
          if (texts[k])   texts[k].classList.toggle('is-active', on);
          if (dots[k]) { dots[k].classList.toggle('is-on', on); dots[k].setAttribute('aria-selected', on ? 'true' : 'false'); }
        }
        // vague sous le téléphone à chaque changement (pas au chargement initial)
        if (!first && media) {
          media.classList.remove('is-wave');
          void media.offsetWidth;
          media.classList.add('is-wave');
        }
      }

      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
      function replay() {
        var s = screens[current];
        if (!s || !s.getAnimations) return;
        s.getAnimations({ subtree: true }).forEach(function (a) { try { a.cancel(); a.play(); } catch (e) {} });
      }
      function startAuto() {
        stopAuto();
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (isMobile && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // Mobile : on reste sur l'écran, seule son animation est rejouée ; le changement d'écran = swipe/points.
        // Desktop sans volet figé : défilement auto historique (les points sont masqués hors mobile).
        timer = setInterval(isMobile ? replay : function () { setActive((current + 1) % n); }, speed);
      }

      var onScroll = function () {
        var rect = root.getBoundingClientRect();
        var total = root.offsetHeight - window.innerHeight;
        if (total <= 0) { setActive(0); return; }
        var p = Math.min(1, Math.max(0, (-rect.top) / total));
        var idx = Math.min(n - 1, Math.floor(p * n));
        setActive(idx);
        // remplissage progressif du point actif (progression dans l'écran courant)
        if (dots[idx]) dots[idx].style.setProperty('--fill', Math.round(Math.min(1, p * n - idx) * 100));
      };

      function teardown() { stopAuto(); window.removeEventListener('scroll', onScroll); }

      function apply() {
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var next = (pinPref && !isMobile && !reduce) ? 'pin' : 'carousel';
        if (next === mode) { if (mode === 'carousel') startAuto(); return; }
        teardown();
        mode = next;
        current = -1;
        if (mode === 'pin') { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
        else { setActive(0); startAuto(); }
      }

      var stage = root.querySelector('.boks-app__stage');
      var swX = 0, swY = 0, swOn = false;
      if (stage) {
        stage.addEventListener('touchstart', function (e) {
          if (mode !== 'carousel') return;
          swOn = true; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!swOn || mode !== 'carousel') return;
          swOn = false;
          var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          setActive(dx < 0 ? (current + 1) % n : (current - 1 + n) % n);
          startAuto();
        }, { passive: true });
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.dataset.i, 10) || 0;
          if (mode === 'pin') {
            // volet figé : l'écran actif dépend du scroll → on amène la page au segment visé
            var total = root.offsetHeight - window.innerHeight;
            var top = root.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: top + total * ((i + 0.5) / n), behavior: 'smooth' });
            return;
          }
          setActive(i);
          startAuto();
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('.boks-app__arr'), function (b) {
        b.addEventListener('click', function () {
          if (mode !== 'carousel') return;
          var dir = b.classList.contains('boks-app__arr--next') ? 1 : -1;
          setActive((current + dir + n) % n);
          startAuto();
        });
      });
      root.addEventListener('mouseenter', function () { if (mode === 'carousel') stopAuto(); });
      root.addEventListener('mouseleave', function () { if (mode === 'carousel') startAuto(); });

      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(apply, 200); });
      apply();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-boks-app]');
      Array.prototype.forEach.call(roots, initApp);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boks-feature-notify"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.BoksBfnNotifs) return;
  window.BoksBfnNotifs = true;
  function play(el){
    el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
    if (!el.hasAttribute('data-bfn-loop')) return;
    // replanifier la boucle : duree totale de la sequence + pause reglee
    var n = el.querySelectorAll('.bfn__card').length;
    var stag = parseFloat(el.style.getPropertyValue('--bfn-stag')) || 600;
    var pause = parseFloat(el.getAttribute('data-bfn-pause')) || 3000;
    var total = 150 + Math.max(0, n - 1) * stag + 700;
    clearTimeout(el._bfnTimer);
    el._bfnTimer = setTimeout(function(){ play(el); }, total + pause);
  }
  function stop(el){
    clearTimeout(el._bfnTimer);
    el.classList.remove('is-in');
  }
  function init(scope){
    (scope || document).querySelectorAll('[data-bfn-notifs]:not([data-bfn-ready])').forEach(function(el){
      el.setAttribute('data-bfn-ready','1');
      var loop = el.hasAttribute('data-bfn-loop');
      if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { play(el); if (!loop) io.disconnect(); }
          else if (loop) { stop(el); }
        });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', function(){ init(); }); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boks-feature-split"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.BoksFsplitList) return;
  window.BoksFsplitList = true;
  function init(scope){
    (scope || document).querySelectorAll('[data-fsplit-list].is-anim:not([data-fsl-ready])').forEach(function(el){
      el.setAttribute('data-fsl-ready','1');
      if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', function(){ init(); }); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boks-web-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWeb(root) {
      if (!root || root.dataset.boksWebReady === '1') return;
      root.dataset.boksWebReady = '1';

      var screens = Array.prototype.slice.call(root.querySelectorAll('.boks-web__screen'));
      var texts   = Array.prototype.slice.call(root.querySelectorAll('.boks-web__text'));
      var dots    = Array.prototype.slice.call(root.querySelectorAll('.boks-web__dot'));
      var n = screens.length;
      if (n <= 1) return;

      var pinPref = root.dataset.pin === 'true';
      var speed = (parseFloat(root.dataset.speed) || 3) * 1000;
      var current = -1, timer = null, mode = '';

      var media = root.querySelector('.boks-web__media');

      function setActive(i) {
        if (i === current || i < 0 || i >= n) return;
        var first = (current === -1);
        current = i;
        for (var k = 0; k < n; k++) {
          var on = (k === i);
          if (screens[k]) screens[k].classList.toggle('is-active', on);
          if (texts[k])   texts[k].classList.toggle('is-active', on);
          if (dots[k]) { dots[k].classList.toggle('is-on', on); dots[k].setAttribute('aria-selected', on ? 'true' : 'false'); }
        }
        // vague derrière le laptop à chaque changement (pas au chargement initial)
        if (!first && media) {
          media.classList.remove('is-wave');
          void media.offsetWidth;
          media.classList.add('is-wave');
        }
      }

      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
      function replay() {
        var s = screens[current];
        if (!s || !s.getAnimations) return;
        s.getAnimations({ subtree: true }).forEach(function (a) { try { a.cancel(); a.play(); } catch (e) {} });
      }
      function startAuto() {
        stopAuto();
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (isMobile && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        // Mobile : on reste sur l'écran, seule son animation est rejouée ; le changement d'écran = swipe/points.
        // Desktop sans volet figé : défilement auto historique (les points sont masqués hors mobile).
        timer = setInterval(isMobile ? replay : function () { setActive((current + 1) % n); }, speed);
      }

      var onScroll = function () {
        var rect = root.getBoundingClientRect();
        var total = root.offsetHeight - window.innerHeight;
        if (total <= 0) { setActive(0); return; }
        var p = Math.min(1, Math.max(0, (-rect.top) / total));
        var idx = Math.min(n - 1, Math.floor(p * n));
        setActive(idx);
        // remplissage progressif du point actif (progression dans l'écran courant)
        if (dots[idx]) dots[idx].style.setProperty('--fill', Math.round(Math.min(1, p * n - idx) * 100));
      };

      function teardown() { stopAuto(); window.removeEventListener('scroll', onScroll); }

      function apply() {
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var next = (pinPref && !isMobile && !reduce) ? 'pin' : 'carousel';
        if (next === mode) { if (mode === 'carousel') startAuto(); return; }
        teardown();
        mode = next;
        current = -1;
        if (mode === 'pin') { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
        else { setActive(0); startAuto(); }
      }

      var stage = root.querySelector('.boks-web__stage');
      var swX = 0, swY = 0, swOn = false;
      if (stage) {
        stage.addEventListener('touchstart', function (e) {
          if (mode !== 'carousel') return;
          swOn = true; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!swOn || mode !== 'carousel') return;
          swOn = false;
          var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          setActive(dx < 0 ? (current + 1) % n : (current - 1 + n) % n);
          startAuto();
        }, { passive: true });
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.dataset.i, 10) || 0;
          if (mode === 'pin') {
            // volet figé : l'écran actif dépend du scroll → on amène la page au segment visé
            var total = root.offsetHeight - window.innerHeight;
            var top = root.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: top + total * ((i + 0.5) / n), behavior: 'smooth' });
            return;
          }
          setActive(i);
          startAuto();
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('.boks-web__arr'), function (b) {
        b.addEventListener('click', function () {
          if (mode !== 'carousel') return;
          var dir = b.classList.contains('boks-web__arr--next') ? 1 : -1;
          setActive((current + dir + n) % n);
          startAuto();
        });
      });
      root.addEventListener('mouseenter', function () { if (mode === 'carousel') stopAuto(); });
      root.addEventListener('mouseleave', function () { if (mode === 'carousel') startAuto(); });

      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(apply, 200); });
      apply();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-boks-web]');
      Array.prototype.forEach.call(roots, initWeb);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
